import script from "./sh-bread.vue?vue&type=script&lang=js"
export * from "./sh-bread.vue?vue&type=script&lang=js"

import "./sh-bread.vue?vue&type=style&index=0&id=3b3808ca&lang=less"

const __exports__ = script;

export default __exports__